import {
  IntlProvider as SharedIntlProvider,
  useWhitelabelIntlProviderState,
  type IntlProviderProps as SharedIntlProviderProps,
} from '@talos/kyoko';
import type { PropsWithChildren } from 'react';

export const translationModules = import.meta.glob<{ default: Record<string, string> }>(
  '../translations/whitelabel.*.json',
  {
    eager: false,
  }
);

export interface WLIntlProviderProps extends Omit<SharedIntlProviderProps, 'loadMessages'> {}

export function WLIntlProvider({ children, ...props }: PropsWithChildren<WLIntlProviderProps>) {
  const { locale, loadMessages, discourageLanguageTranslation } = useWhitelabelIntlProviderState(translationModules);

  if (locale == null) {
    // Whitelabel UI checks your config for locale preferences before rendering the WLIntlProvider
    return null;
  }

  return (
    <SharedIntlProvider
      {...props}
      loadMessages={loadMessages}
      locale={locale}
      shouldDiscourageLanguageTranslation={discourageLanguageTranslation}
    >
      {children}
    </SharedIntlProvider>
  );
}
